import Navbar from '../components/Navbar/Navbar';
import Footer from '../components/Footer/Footer';
import '../styles/Pages.css';

function SSSPage() {
    return (
        <div className="page-wrapper">
            <Navbar />
            <div className="page-hero">
                <p className="page-breadcrumb"><a href="/">Home</a> › Student Satisfaction Survey</p>
                <h1>Student Satisfaction Survey (SSS)</h1>
                <p>Your feedback helps us improve the quality of teaching and learning.</p>
            </div>
            <div className="page-content">
                <div className="info-card">
                    <h2>About SSS</h2>
                    <p>The Student Satisfaction Survey on Teaching-Learning Process is mandatory as per NAAC guidelines. It is conducted annually to assess student satisfaction across dimensions like curriculum relevance, faculty effectiveness, facilities, and administration.</p>
                    <ul style={{ marginTop: '0.8rem' }}>
                        <li>All enrolled students are requested to participate honestly.</li>
                        <li>Responses are completely <strong>anonymous and confidential</strong>.</li>
                        <li>Results are used by IQAC to improve institutional quality.</li>
                    </ul>
                </div>
                <div className="info-card">
                    <h2>Survey Link</h2>
                    <p>The official SSS survey is hosted on the NAAC portal. Use the link below to submit your response:</p>
                    <div className="ext-links">
                        <a href="https://www.naac.gov.in" target="_blank" rel="noreferrer" className="ext-link-chip">🔗 NAAC SSS Portal</a>
                        <a href="/feedback/student" className="ext-link-chip">📝 Internal Student Feedback</a>
                    </div>
                </div>
            </div>
            <Footer />
        </div>
    );
}
export default SSSPage;
